import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { UserPlus } from 'lucide-react'
import { ModalContent } from './ModalContent'


export function AddUserDialog() {
 
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="rounded-full bg-secondary hover:bg-accent"
        onClick={() => setIsOpen(true)}
      >
        <UserPlus className="h-5 w-5" />
      </Button>

      <ModalContent
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}